import { render } from "./FormComponent.vue?vue&type=template&id=c04a72d8&scoped=true&ts=true"
import script from "./FormComponent.vue?vue&type=script&lang=ts"
export * from "./FormComponent.vue?vue&type=script&lang=ts"

import "./FormComponent.vue?vue&type=style&index=0&id=c04a72d8&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c04a72d8"]])

export default __exports__